// Package imports:
import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
// Component imports:
import Logo from './Logo/Logo';
import Nav from './Nav/Nav';
import Search from './Search/Search';
import NavAccess from './NavAccess/NavAccess';
import MobileHamburgerMenu from './MobileHamburgerMenu/MobileHamburgerMenu';
// Service imports:
import { isElementSubChild } from '../../services/utils';

const Header: React.FC = () => {
    const headerRef = useRef<HTMLElement | null>(null);
    const [ isMobileNavMenuOpen, setIsMobileNavMenuOpen ] = useState(false);
    // Used to shift navbar around, to give space to the input field.
    const [ isSmallSearchInputFieldFocused, setIsSmallSearchInputFieldFocused ] = useState(false);
    // We don't want the search to "unfocus" when we click out of the search alone.
    // Because there are many buttons in the nav bar that will shift around when we unfocus the state.
    // So therefore, to focus: click the input.
    // But to unfocus, you have to click an element that is not inside the header.
    // For this we will have a helper function, and a document event listener.
    const focusSearchInputField = () => setIsSmallSearchInputFieldFocused(true);
    useEffect(() => {
        const outOfHeaderClickListener = (e: MouseEvent) => {
            const { target } = e;
            const headerElement = headerRef.current;
            if (target instanceof Element && headerElement) {
                // If user clicks on element, which is not in header, then turn off focus.
                if (!isElementSubChild(target, headerElement)) {
                    setIsSmallSearchInputFieldFocused(false)
                }
            } else {
                setIsSmallSearchInputFieldFocused(false)
            }
        }
        document.addEventListener('click', outOfHeaderClickListener);
        return () => document.removeEventListener('click', outOfHeaderClickListener);
    })

    return (
        <header
            ref={headerRef}
            className={cx("KCL_header", {
                'is-search-input-focused': isSmallSearchInputFieldFocused
            })}
        >
            {/* Add pink-ribbon class for pink ribbon theme, pride class for pride theme */}
            <div className="header-content">
                <div className='header-upper-left'>
                    <div className="logo-wrapper">
                        <Logo />
                    </div>
                    <div className='search-wrapper'>
                        <Search
                            focusSearchInputField={focusSearchInputField}
                        />
                    </div>
                </div>
                <div className={cx('header-upper-center', {
                    'is-mobile-nav-menu-open': isMobileNavMenuOpen
                })}>
                    <Nav
                        onMenuExitClick={() => setIsMobileNavMenuOpen(false)}
                    />
                </div>
                <div className='header-upper-right'>
                    <NavAccess />
                    <MobileHamburgerMenu
                        onClick={() => setIsMobileNavMenuOpen(true)}
                    />
                </div>
            </div>
        </header>
    )
}

export default Header
